export class RutsolveToken {
    static readonly key: string = "RUTSOLVE_TOKEN"

    public static read(): string {
        const localValue = localStorage.getItem(this.key)
        const sessionValue = sessionStorage.getItem(this.key)
        if (sessionValue != null) {
            return sessionValue
        }
        if (localValue != null) {
            return localValue
        }
        return null
    }

    public static write(token: string, save?: boolean) {
        localStorage.removeItem(this.key)
        sessionStorage.setItem(this.key, token)
        if (save) {
            localStorage.setItem(this.key, token)
        }
    }

    public static delete() {
        localStorage.removeItem(this.key)
        sessionStorage.removeItem(this.key)
    }
}
